const getMaxCount = (count: number) => {
  if (count > 99) {
    return '99+'
  }
  return count || ''
}

export default getMaxCount
